<template>
	<div
		:class="['panel',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
		]"
	>
		<div class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<div class="row align-items-end">
					<div class="col-12 col-md-9" :class="block.image ? 'col-md-9' : 'col-md-12'">
						<h2>{{ block.block_title }}</h2>
						<div class="description border-md-bottom">
							<div v-if="block.description" class="title" v-html="block.description" />
						</div>
					</div>
					<div v-if="block.image" class="col-12 col-md-3">
						<div class="description border-bottom mt-3 mt-md-0">
							<p class="image">
								<img :src="block.image" alt="">
							</p>
							<div class="title">
								<p>{{ block.image_title }}</p>
							</div>
						</div>
					</div>
				</div>
				<!-- <nuxt-link class="panel_control" to="#"></nuxt-link> -->
			</div>

			<div class="row">
				<div class="col-12">
					<div v-if="block.display_as_slider" class="history-timeline">
						<div v-swiper:menuSwiper="options">
							<div class="swiper-wrapper">
								<div
									v-for="(item, index) in block.items"
									:key="index"
									class="swiper-slide"
								>
									<div class="timeline-block">
										<div v-if="item.title" class="year">
											{{ item.title }}
										</div>
										<div v-if="item.text" class="description" v-html="item.text" />
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-else class="history-timeline block">
						<div class="row mx-0">
							<div
								v-for="(item, index) in block.items"
								:key="index"
								class="col-12 col-md-6 col-lg-3"
							>
								<div class="timeline-block">
									<div v-if="item.title" class="year">
										{{ item.title }}
									</div>
									<div v-if="item.text" class="description" v-html="item.text" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="isFooterVisible" class="row flex-row-reverse mb-5">
				<div v-if="block.display_as_slider" class="col-12 col-sm-4">
					<div class="swiper-navigation">
						<div :id="prevElId" class="btn btn-outline-primary icon-arrow_prev" />
						<div :id="nextElId" class="btn btn-outline-primary icon-arrow_next" />
					</div>
				</div>
				<div class="col-12 col-sm-8">
					<!-- Для футер-кнопок -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import panel from '~/mixins/panel';


export default {
	name: 'SchoolHistory',
	components: {
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},
	mixins: [panel],
	data() {
		return {
			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				// cssMode: false,
				// freeMode: true,
				loop: false,

				navigation: {
					prevEl: `#swiper-timeline-prev_${this.block.id}`,
					nextEl: `#swiper-timeline-next_${this.block.id}`,
					disabledClass: 'disabled',
				},
			},
		};
	},
	computed: {
		prevElId() {
			return this.options.navigation.prevEl.slice(1);
		},
		nextElId() {
			return this.options.navigation.nextEl.slice(1);
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-school-history";
	.history-timeline {
		overflow: hidden!important;
		
		.swiper-wrapper {
			align-items: stretch!important;
		}
	}
</style>
